
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M8.5 15.5h-4a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3m-7 2h2m-2-3h4m-.227 5.48-2.544.941a.35.35 0 0 0 0 .658l2.544.941a.35.35 0 0 1 .207.207l.941 2.544a.35.35 0 0 0 .658 0l.941-2.544a.35.35 0 0 1 .207-.207l2.544-.941a.35.35 0 0 0 0-.658l-2.544-.941a.35.35 0 0 1-.207-.207l-.941-2.544a.35.35 0 0 0-.658 0l-.941 2.544a.35.35 0 0 1-.207.207Z"}})])
          )
        }
      }
    